import { State, Action, StateContext } from '@ngxs/store';
import { Institute } from '../../models/institute/randomInstituteResponse';

export class AddMyInstitute {
  static readonly type = '[MyInstitute] Add My Institute';
  constructor(public payload: {item:Institute}) {}
}

export class RemoveMyInstitute {
  static readonly type = '[MyInstitute] Remove My Institute';
  constructor(public payload: {instituteId:string, studentId: string}) {}
}

export class SetMyAddedInstitute {
  static readonly type = '[MyInstitute] Set My Institutes';
  constructor(public payload: {items:Institute[]}) {}
}

export class UpdateMyInstitutesList {
  static readonly type = '[MyInstitute] Update List';
  constructor(public payload: Institute) {} 
}
